import * as React from "react"
import { FiChevronRight } from "react-icons/fi"
import {
  Box,
  Heading,
  Button,
  Collapse,
  Icon,
  useColorMode,
} from "@chakra-ui/react"
import { Filters } from "./Filters"
import { IItem, Item, ItemFilter, items } from "./Item"
import { Ceremony } from "./Ceremony"
import { InfoModalButton } from "./InfoModalButton"

export const Main = () => {
  const { colorMode } = useColorMode()
  const [filter, setFilter] = React.useState<ItemFilter>({
    moods: [],
    withWhom: "friends",
    location: "indoors",
    when: "today",
  })
  const [selectableItems, setSelectableItems] = React.useState<IItem[]>([])
  const [selectedIds, setSelectedIds] = React.useState<Set<string>>(new Set())
  const [tripReady, setTripReady] = React.useState(false)

  const toggleItemSelection = React.useMemo(() => {
    return (itemId: string) => {
      if (selectedIds.has(itemId)) {
        selectedIds.delete(itemId)
      } else {
        selectedIds.add(itemId)
      }
      setSelectedIds(new Set(selectedIds))
    }
  }, [selectedIds])

  // @TODO It doesn't clear the menu group selection state
  // const startOver = () => {
  //   setMoods([]);
  //   setWho("myself");
  //   setLocation("indoors")
  //   setWhen("today")
  //   setSelectedIds(new Set());
  //   setTripReady(false);
  // }

  return (
    <Box>
      <Filters
        tripReady={tripReady}
        filter={filter}
        setFilter={setFilter}
        selectedIds={selectedIds}
        setSelectableItems={setSelectableItems}
      />

      <Box maxWidth={728} textAlign="left" mx="auto">
        <Collapse in={!!selectedIds.size} animateOpacity>
          <Box mt={12} mb={16}>
            <Collapse in={tripReady} animateOpacity>
              <Box mb={8}>
                <InfoModalButton>
                  Before you get started <Icon as={FiChevronRight} />
                </InfoModalButton>
              </Box>
            </Collapse>
            <Heading my={4} fontSize="2xl" textAlign="left">
              {tripReady ? "The Ceremony" : "The plan so far"}
            </Heading>
            <Collapse in={tripReady} animateOpacity>
              <Box my={8}>
                <Ceremony withWhom={filter.withWhom} />
              </Box>
              <Heading my={4} fontSize="2xl">
                The Plan
              </Heading>
            </Collapse>

            <Box textAlign="left" mx="auto" display="inline-block">
              {Array.from(selectedIds).map((itemId) => (
                <Item
                  toggleItemSelection={toggleItemSelection}
                  selected={true}
                  key={itemId}
                  hideCheckbox={tripReady}
                  {...items[itemId]}
                />
              ))}
            </Box>

            <Box mt={4} textAlign="center">
              {/*@TODO change bg gradient as you add more items*/}
              <Button
                bgGradient={
                  tripReady
                    ? colorMode === "light"
                      ? "linear(to-r, teal.200 0%, blue.200 75%, teal.200 100%)"
                      : "linear(to-r, teal.700 0%, blue.700 75%, teal.700 100%)"
                    : colorMode === "light"
                    ? "linear(to-r, red.400 0%, orange.400 75%, red.400 100%)"
                    : "linear(to-r, red.500 0%, orange.500 75%, red.500 100%)"
                }
                _hover={{
                  backgroundPosition: -120,
                }}
                sx={{
                  backgroundSize: 120,
                  transition: "background 0.15s ease-in-out",
                }}
                onClick={() => setTripReady(!tripReady)}
              >
                {tripReady ? "Modify trip" : "I'm ready"}
              </Button>
              {/*{tripReady && <Button  ml={4} onClick={startOver}>Start over</Button>}*/}
            </Box>
          </Box>
        </Collapse>

        <Collapse in={!tripReady} animateOpacity>
          {!!filter.moods.length && (
            <>
              <Heading my={4} fontSize="2xl">
                Here's what {selectedIds.size ? "else " : ""}you can do
              </Heading>
              {selectableItems.map((item) => {
                return (
                  <Item
                    key={item.id}
                    {...item}
                    toggleItemSelection={toggleItemSelection}
                  />
                )
              })}
            </>
          )}
        </Collapse>
      </Box>
    </Box>
  )
}
